import React from "react";

function formatDateLocal(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

const nomiGiorni = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];

export default function AgendaCalendar({
  agenda,
  mese,
  anno,
  onPrevMonth,
  onNextMonth,
  onDayClick
}) {

  const primoGiornoMese = new Date(anno, mese, 1);
  const ultimoGiornoMese = new Date(anno, mese + 1, 0);

  let primoIndice = primoGiornoMese.getDay();
  primoIndice = primoIndice === 0 ? 6 : primoIndice - 1;

  const celleVuoteInizio = Array.from({ length: primoIndice }, (_, i) => ({
    id: `empty-start-${i}`,
    vuota: true
  }));

  const giorni = [];

  for (let i = 1; i <= ultimoGiornoMese.getDate(); i++) {
    giorni.push({
      id: `day-${i}`,
      data: new Date(anno, mese, i),
      numero: i,
      vuota: false
    });
  }

  const celleTotali = [...celleVuoteInizio, ...giorni];

  const resto = celleTotali.length % 7;

  const celleVuoteFine =
    resto === 0
      ? []
      : Array.from({ length: 7 - resto }, (_, i) => ({
          id: `empty-end-${i}`,
          vuota: true
        }));

  const celleFinali = [...celleTotali, ...celleVuoteFine];


  // 🔎 trova evento del giorno
function eventiDelGiorno(data) {

  const giorno = formatDateLocal(data);

  return agenda.filter(e => {

    if (!e.data_evento) return false;

    const dataEvento = String(e.data_evento).split("T")[0];

    return dataEvento === giorno;

  });

}

  // 🎨 stato giorno (colore)
  function statoGiorno(data) {

    const giorno = formatDateLocal(data);

    const eventi = agenda.filter(e => {

      if (!e.data_evento) return false;

      const dataEvento = String(e.data_evento).split("T")[0];

      return dataEvento === giorno;

    });

    if (!eventi.length) return "";

    const oggi = formatDateLocal(new Date());

    if (eventi.some(e => e.opzione === "No")) return "confermato";

    if (
      eventi.some(
        e => e.opzione === "Si" && e.scadenza && e.scadenza < oggi
      )
    ) {
      return "scaduto";
    }

    return "opzione";
  }


  const titoloMese = new Date(anno, mese).toLocaleDateString("it-IT", {
    month: "long",
    year: "numeric"
  });


  return (
    <div className="agenda-calendar">

      {/* HEADER MESE */}
 <div className="calendar-toolbar">

  <button
    className="calendar-nav-btn"
    aria-label="Mese precedente"
    onClick={onPrevMonth}
  >
    ‹
  </button>

  <div className="calendar-title">
    {titoloMese.charAt(0).toUpperCase() + titoloMese.slice(1)}
  </div>

  <button
    className="calendar-nav-btn"
    aria-label="Mese successivo"
    onClick={onNextMonth}
  >
    ›
  </button>

</div>


      {/* GIORNI SETTIMANA */}
      <div className="calendar-weekdays">

        {nomiGiorni.map(g => (
          <div
            key={g}
            className="calendar-weekday"
          >
            {g}
          </div>
        ))}

      </div>


      {/* GRIGLIA GIORNI */}
      <div className="calendar-grid">

        {celleFinali.map(cella => {

          if (cella.vuota) {
            return (
              <div
                key={cella.id}
                className="calendar-day empty"
              ></div>
            );
          }

          const stato = statoGiorno(cella.data);

          return (
           <div
  key={cella.id}
  className={`calendar-day ${stato}`}
  data-day={cella.numero}
  role="button"
  tabIndex={0}
  aria-label={cella.data.toLocaleDateString('it-IT') + ', ' + eventiDelGiorno(cella.data).length + ' eventi'}
  onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); const events = eventiDelGiorno(cella.data); if (events.length && onDayClick) onDayClick(events); } }}
              onClick={() => {

const eventi = eventiDelGiorno(cella.data);

if (eventi.length && onDayClick) {
  onDayClick(eventi);
}
              }}
            >

          <div className="calendar-day-number">
  {cella.numero}
</div>

{eventiDelGiorno(cella.data).map((ev,i) => (
  <div key={i} className="calendar-event-name">
    {ev.nome_evento}
  </div>
))}
            </div>
          );

        })}

      </div>

    </div>
  );
}